// TODO(SuperPaintman): Remove those rules later
/* tslint:disable:no-console */

import {isBrowser} from '@eda.yandex/ui-kit/lib/device-detect'
import config from 'common/config'

type LoggerLevel = (...args: any[]) => void

const ERROR = 1
const WARNING = 2
const INFO = 3
const DEBUG = 4
const noop = () => undefined

const LOG_LEVELS = {
  [ERROR]: 'ERROR',
  [WARNING]: 'WARNING',
  [INFO]: 'INFO',
  [DEBUG]: 'DEBUG'
}

const logLevel = config.logLevel

const DATE_STRING_LENGTH = 19
const timestamp = () => (
  new Date()
    .toISOString()
    .slice(0, DATE_STRING_LENGTH)
    .replace('T', ' ')
)

/* tslint:disable:no-console */
const error: LoggerLevel = isBrowser()
  ? console.error.bind(console)
  : (...args) => console.error(`${timestamp()} ERROR:`, ...args)
const warn: LoggerLevel = isBrowser()
  ? console.debug.bind(console)
  : (...args) => console.debug(`${timestamp()} WARNING:`, ...args)
const info: LoggerLevel = isBrowser()
  ? console.info.bind(console)
  : (...args) => console.info(`${timestamp()} INFO:`, ...args)
const debug: LoggerLevel = isBrowser()
  ? console.log.bind(console)
  : (...args) => console.log(`${timestamp()} DEBUG:`, ...args)
/* tslint:enable:no-console */

export const logError = logLevel >= ERROR
  ? (err: Error | ErrorEvent | string) => {
    /* tslint:disable-next-line */
    // if (isBrowser()) {
    //   Sentry.captureException(err)
    // }
    return error(err)
  }
  : noop
export const logWarning = logLevel >= WARNING ? warn : noop
export const logInfo = logLevel >= INFO ? info : noop
export const logDebug = logLevel >= DEBUG ? debug : noop

logInfo(`log level: ${LOG_LEVELS[logLevel]}`)
